package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.export.CertificadoDados
import br.com.htms.inspeccaocampo.export.CertificadoModelo
import br.com.htms.inspeccaocampo.export.CertificadoPdfBuilder
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.AppTab
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun SharedCertificadoScreen(
    controller: AppController,
    embutido: Boolean = false,
    modeloInicial: CertificadoModelo? = null
) {
    val gerando by controller.gerandoCertificado.collectAsState()
    val versaoDocs by controller.documentosVersao.collectAsState()
    val funcionarioInicial by controller.certificadoFuncionarioInicial.collectAsState()
    val hoje = remember { formatDateBr(currentTimeMillis()).substringBefore(' ') }

    var funcionarios by remember { mutableStateOf<List<Funcionario>>(emptyList()) }
    var funcionario by remember { mutableStateOf<Funcionario?>(null) }
    var modelo by remember { mutableStateOf(modeloInicial ?: CertificadoModelo.NR35) }
    var inicio by remember { mutableStateOf(hoje) }
    var fim by remember { mutableStateOf(hoje) }
    var dataEmissao by remember { mutableStateOf(hoje) }
    var cidade by remember { mutableStateOf((modeloInicial ?: CertificadoModelo.NR35).cidadePadrao) }
    var cidadeEditada by remember { mutableStateOf(false) }
    var fimManual by remember { mutableStateOf(false) }
    var emissaoManual by remember { mutableStateOf(false) }
    var tentouGerar by remember { mutableStateOf(false) }

    fun aplicarDatasPorCarga() {
        if (!CertificadoPdfBuilder.dataValida(inicio)) return
        val horas = CertificadoPdfBuilder.horasCarga(modelo.cargaHoraria)
        val (f, e) = CertificadoPdfBuilder.periodoEEmissaoPorCarga(inicio, horas)
        if (!fimManual) fim = f
        if (!emissaoManual) dataEmissao = e
    }

    LaunchedEffect(modelo, inicio) { aplicarDatasPorCarga() }

    LaunchedEffect(versaoDocs) {
        FuncionariosApi.listar().onSuccess { lista ->
            funcionarios = lista
            funcionario?.let { atual -> funcionario = lista.firstOrNull { it.id == atual.id } ?: atual }
        }
    }
    LaunchedEffect(funcionarioInicial) {
        funcionarioInicial?.let {
            funcionario = it
            controller.consumirCertificadoFuncionarioInicial()
        }
    }

    val inicioOk = CertificadoPdfBuilder.dataValida(inicio)
    val fimOk = CertificadoPdfBuilder.dataValida(fim) && (!inicioOk || CertificadoPdfBuilder.periodoValido(inicio, fim))
    val emissaoOk = CertificadoPdfBuilder.dataValida(dataEmissao)
    val cidadeOk = cidade.isNotBlank()
    val podeGerar = funcionario != null && inicioOk && fimOk && emissaoOk && cidadeOk && !gerando

    DocumentosModulo(controller, AppTab.CERTIFICADO, "Certificados", embutido = embutido) {
        CartaoSecao(
            titulo = "Emissão de certificado",
            subtitulo = "Modelo oficial do curso com o nome e o CPF do funcionário cadastrado no texto e no campo de assinatura do aluno. " +
                "As assinaturas do engenheiro/instrutor e o conteúdo programático (página 2) não mudam."
        ) {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        FuncionarioSeletor(
            funcionarios = funcionarios,
            selecionado = funcionario,
            onSelecionar = { funcionario = it },
            onTrocar = { funcionario = null }
        )
        if (tentouGerar && funcionario == null) {
            Text(
                "Selecione um funcionário cadastrado (cadastre em Funcionários se ainda não existir).",
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall
            )
        }

        Text("Curso", fontWeight = FontWeight.SemiBold)
        FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
            CertificadoModelo.entries.forEach { m ->
                FilterChip(
                    selected = modelo == m,
                    onClick = {
                        modelo = m
                        if (!cidadeEditada) cidade = m.cidadePadrao
                        fimManual = false
                        emissaoManual = false
                    },
                    label = { Text(m.rotulo) }
                )
            }
        }
        Text(
            "${modelo.curso} • ${modelo.cargaHoraria} • NR ${modelo.norma}",
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )
        Text(
            "Fim e emissão calculados com ${CertificadoPdfBuilder.diasTreinamento(CertificadoPdfBuilder.horasCarga(modelo.cargaHoraria))} " +
                "dia(s) de treino (8 h/dia, segunda a sábado; domingo não conta). Você pode ajustar manualmente.",
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )

        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            Column(Modifier.weight(1f)) {
                AppDateTextField(
                    value = inicio,
                    onValueChange = {
                        inicio = it
                        fimManual = false
                        emissaoManual = false
                    },
                    label = "Início do curso",
                    isError = !inicioOk
                )
            }
            Column(Modifier.weight(1f)) {
                AppDateTextField(
                    value = fim,
                    onValueChange = {
                        fim = it
                        fimManual = true
                    },
                    label = "Fim do curso",
                    isError = !fimOk
                )
            }
        }
        if (inicioOk && CertificadoPdfBuilder.dataValida(fim) && !fimOk) {
            Text(
                "O fim do curso não pode ser antes do início.",
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall
            )
        }
        if (inicioOk && fimOk) {
            Text(
                "No certificado: \"realizado ${CertificadoPdfBuilder.periodoPorExtenso(inicio, fim)}.\"",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }

        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            Column(Modifier.weight(1f)) {
                AppDateTextField(
                    value = dataEmissao,
                    onValueChange = {
                        dataEmissao = it
                        emissaoManual = true
                    },
                    label = "Data de emissão",
                    isError = !emissaoOk
                )
            }
            AppOutlinedTextField(
                value = cidade,
                onValueChange = {
                    cidade = it
                    cidadeEditada = true
                },
                label = { Text("Cidade - UF") },
                singleLine = true,
                isError = tentouGerar && !cidadeOk,
                modifier = Modifier.weight(1f),
                colors = FormFieldDefaults.textFieldColors()
            )
        }
        if (emissaoOk && cidadeOk) {
            Text(
                "No certificado: \"${cidade.trim()}, ${CertificadoPdfBuilder.dataPorExtenso(dataEmissao)}.\"",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }

        PortalButton(
            onClick = {
                tentouGerar = true
                val f = funcionario ?: return@PortalButton
                if (!podeGerar) return@PortalButton
                controller.gerarCertificadoPdf(
                    CertificadoDados(
                        modelo = modelo,
                        nome = f.nome,
                        cpf = f.cpf,
                        inicio = inicio,
                        fim = fim,
                        dataEmissao = dataEmissao,
                        cidade = cidade.trim()
                    ),
                    f
                )
            },
            enabled = !gerando,
            modifier = Modifier.fillMaxWidth()
        ) {
            if (gerando) {
                CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp)
                Text("  Gerando PDF...")
            } else {
                Text("Gerar certificado e salvar no cadastro")
            }
        }

        }
        }

        funcionario?.let { FuncionarioDocumentosPanel(controller, it) }
    }
}
